module.exports = __webpack_public_path__ + "img/logo_tt.7a9cee43.svg";